class RollingConversation {
    init(_option) {
        this.option = $.extend(true, {
            selector: '.wrap_content.current .conversation li',
            activeIdx: 0,
            intervalTime: 5000,
            callbackFN: _idx => console.log('rollingConversation callback', _idx)
        }, _option);

        this.list = $(this.option.selector);
        this.currentIdx = this.option.activeIdx;

        this.go(this.currentIdx);
        this.resetInterval();
        this.addEvents();

    }

    resetInterval() {
        let _this = this;

        this.interval = setInterval(function () {
            _this.next();
        }, this.option.intervalTime);
    }

    updateIndex() {
        if (this.currentIdx >= this.list.length - 1) {
            this.currentIdx = 0;
        } else {
            this.currentIdx++;
        }
    }

    updateTarget(_selector) {
        this.list.unbind('click');
        this.list = $(_selector).length ? $(_selector) : $(this.option.selector);
        this.resetInterval();
        this.addEvents();
    }

    go(_idx) {
        this.currentIdx = _idx;
        this.list.hide();
        this.list.eq(this.currentIdx).show();
    }

    next() {
        this.updateIndex();
        this.go(this.currentIdx);
    }

    addEvents() {
        const _this = this;
        //console.log('addEvents');
        _this.list.on('click', function () {
            console.log('addEvent onclick', (_this.currentIdx + 1), _this.list);
            _this.destroy(_this.interval);
            _this.next();
            _this.resetInterval();
        });
    }

    destroy() {
        console.log('destroy');
        clearInterval(this.interval);
    }
}

export default RollingConversation;